<template>
    <div class="button-select" v-bind="$attrs">
        <ui5-button ref="button" design="Default" @click="onButtonClick">
            {{ selectedValue }}
        </ui5-button>

        <ui5-responsive-popover
            ref="options"
            hide-arrow="true"
            :placement-type="isNearBottom ? 'Bottom' : 'Top'"
            vertical-align="Center"
            horizontal-align="Stretch">
            <ui5-list
                v-if="showOptions"
                mode="SingleSelectAuto"
                separators="None">
                <ui5-li v-if="showNullOption" @click="onValueSelect(null)">
                    {{ nullLabel }}
                </ui5-li>

                <ui5-li
                    v-for="option in options"
                    :key="option.value || option.label"
                    :class="{
                        'header-option': option.isHeader,
                        'field-option': !option.isHeader && !option.isOption,
                        'datafield-option': option.isOption
                    }"
                    @click="!option.disabled && onValueSelect(option.value)">
                    {{ option.label }}
                </ui5-li>
            </ui5-list>
        </ui5-responsive-popover>
    </div>
</template>
<script>
export default {
    props: {
        options: {
            type: Array, // label, value
            required: true,
        },
        value: {
            default: null,
        },
        showNullOption: {
            type: Boolean,
            default: true,
        },
        nullLabel: {
            type: String,
            default: '---',
        },
    },
    data() {
        return {
            showOptions: false,
        };
    },
    computed: {
        isNearBottom() {
            if (!this.$refs.button) {
                return false;
            }

            return (
                this.$refs.button.getBoundingClientRect().bottom <
                window.innerHeight / 3
            );
        },
        selectedValue() {
            const option = this.options.find((o) => o.value === this.value);
            return option ? option.label : this.nullLabel;
        },
    },
    methods: {
        onButtonClick() {
            this.showOptions = true;
            this.$refs.options.showAt(this.$refs.button);
        },
        onValueSelect(value) {
            this.$emit('input', value);
            this.$refs.options.close();
        },
    },
};
</script>

<style lang="scss">
.button-select {
    --_ui5_popup_content_padding_s: 0 !important;

    ui5-button {
        width: var(--_ui5_input_width);
        border: 1px solid var(--sapField_BorderColor);
        background-color: var(--_ui5-input-background-color);

        text-align: start;
        color: var(--sapField_TextColor);
        font-size: var(--sapFontSize);
    }

    &.error ui5-button {
        border-color: red;
    }

    .header-option {
        font-weight: bold;
        color: white !important;
        cursor: default !important;
        pointer-events: none;
    }
}
</style>
